/*
  CatchFish sticky add-to-cart bar (mobile).
  Mirrors the real product form button and clicks it, so all Shopify
  behaviour (variants, cart drawer, analytics, errors) is unchanged.
*/
if (!customElements.get('cf-sticky-atc')) {
  customElements.define(
    'cf-sticky-atc',
    class CfStickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.button = this.querySelector('[data-cf-sticky-button]');
        this.label = this.button ? this.button.querySelector('span') : null;
        this.priceTarget = this.querySelector('[data-cf-sticky-price]');
        this.onClick = this.onClick.bind(this);
        if (this.button) this.button.addEventListener('click', this.onClick);

        this.observeMainButton();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (!event || !event.data || event.data.sectionId === this.sectionId) this.sync();
          });
        }

        this.sync();
      }

      disconnectedCallback() {
        if (this.intersectionObserver) this.intersectionObserver.disconnect();
        if (this.mutationObserver) this.mutationObserver.disconnect();
        if (this.unsubscribe) this.unsubscribe();
        document.body.classList.remove('cf-sticky-atc-visible');
      }

      get mainButton() {
        return document.getElementById(`ProductSubmitButton-${this.sectionId}`);
      }

      observeMainButton() {
        const mainButton = this.mainButton;
        if (!mainButton || !('IntersectionObserver' in window)) return;

        this.intersectionObserver = new IntersectionObserver(([entry]) => {
          const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.setVisible(scrolledPast);
        });
        this.intersectionObserver.observe(mainButton);

        this.mutationObserver = new MutationObserver(() => this.sync());
        this.mutationObserver.observe(mainButton, {
          attributes: true,
          attributeFilter: ['disabled'],
          childList: true,
          subtree: true,
          characterData: true,
        });
      }

      setVisible(visible) {
        this.classList.toggle('is-visible', visible);
        this.setAttribute('aria-hidden', String(!visible));
        if (visible) {
          this.removeAttribute('inert');
        } else {
          this.setAttribute('inert', '');
        }
        document.body.classList.toggle('cf-sticky-atc-visible', visible);
      }

      sync() {
        const mainButton = this.mainButton;
        if (!mainButton || !this.button) return;

        this.button.disabled = mainButton.hasAttribute('disabled');
        const mainLabel = mainButton.querySelector('span');
        if (mainLabel && this.label) this.label.textContent = mainLabel.textContent.trim();

        const price = document.getElementById(`price-${this.sectionId}`);
        if (price && this.priceTarget) {
          const current = price.querySelector('.price-item--last');
          this.priceTarget.textContent = current ? current.textContent.trim() : '';
        }
      }

      onClick() {
        const mainButton = this.mainButton;
        if (!mainButton) return;
        if (mainButton.hasAttribute('disabled')) {
          mainButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        mainButton.click();
      }
    }
  );
}
